import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { Action, Selector, State } from '@ngxs/store';
import { SetEnvironment } from './app-environment.actions';
import * as i0 from "@angular/core";
let AppEnvironmentState = class AppEnvironmentState {
  static appEnvironmentState(state) {
    return state;
  }
  static environment(state) {
    return state.environment;
  }
  setEnvironment({
    patchState
  }, action) {
    return patchState({
      environment: action.environment
    });
  }
  static ɵfac = function AppEnvironmentState_Factory(t) {
    return new (t || AppEnvironmentState)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppEnvironmentState,
    factory: AppEnvironmentState.ɵfac
  });
};
__decorate([Action(SetEnvironment)], AppEnvironmentState.prototype, "setEnvironment", null);
__decorate([Selector()], AppEnvironmentState, "appEnvironmentState", null);
__decorate([Selector()], AppEnvironmentState, "environment", null);
AppEnvironmentState = __decorate([State({
  name: 'appEnvironmentState',
  defaults: {
    environment: null
  }
})], AppEnvironmentState);
export { AppEnvironmentState };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppEnvironmentState, [{
    type: Injectable
  }], null, {
    setEnvironment: []
  });
})();
